export enum MultimediaTypes {
  pdf = 'pdf',
  ppt = 'ppt',
  video = 'video',
  image = 'image',
}
